export default "__VITE_ASSET__jbs8lwV9__"